import { rootActionTypes, ClearStateAction } from "@/fe-core/meta/types/root";

export const clearState = (): ClearStateAction => ({
  type: rootActionTypes.CLEAR_STATE,
});
